import { type HTMLChakraProps, chakra } from '@chakra-ui/react';
import * as React from 'react';

export interface BadgeProps extends HTMLChakraProps<'span'> {
  /** Disables the badge (muted color scheme). */
  disabled?: boolean;
}

/**
 * Pill-shaped count badge used beside tab labels and inline in table cells.
 *
 * Renders its children (typically a number or "+N" string) in a compact
 * pill with the brand color scheme. When `disabled`, switches to neutral.
 */
export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(function Badge(props, ref) {
  const { disabled, ...rest } = props;

  return (
    <chakra.span
      ref={ref}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      minW="18px"
      px="1"
      borderRadius="full"
      bg={disabled ? 'neutral.100' : 'brand.100'}
      color={disabled ? 'neutral.250' : 'brand.500'}
      textStyle="small.medium"
      {...rest}
    />
  );
});
Badge.displayName = 'Badge';
